import { render, staticRenderFns } from "./UiCountdownSimple.vue?vue&type=template&id=cc3ebd2a&lang=pug&"
import script from "./UiCountdownSimple.vue?vue&type=script&lang=js&"
export * from "./UiCountdownSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports